export default function equals() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link(scope, elem, attrs, ngModel) {
      if (!ngModel) {
        return;
      }

      function validate() {
        const val1 = ngModel.$viewValue;
        const val2 = attrs.equals;
        ngModel.$setValidity('equals', val1 === val2);
      }

      // watch own value and re-validate on change
      scope.$watch(attrs.ngModel, validate);

      // observe the other value and re-validate on change
      attrs.$observe('equals', validate);
    },
  };
}
